/**
 * Parse NFe XML and return header + items for persistence.
 * @param {string} text - Raw XML string
 * @returns {{ chave_nfe: string, emit_cnpj: string, dest_cnpj: string, dt_emissao: string|null, itens: Array }} or throws on invalid XML
 */
export function parseNFeXml(text) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, "text/xml");

  const parseError = doc.querySelector("parsererror");
  if (parseError) {
    throw new Error("XML inválido: " + (parseError.textContent || "erro de parsing"));
  }

  const infNFe = findByLocalName(doc, "infNFe");
  if (!infNFe) {
    throw new Error("NFe inválida: elemento infNFe não encontrado");
  }

  const chave_nfe = (infNFe.getAttribute("Id") || infNFe.getAttribute("id") || "").trim();
  const emit = findByLocalName(infNFe, "emit");
  const cnpjEmit = emit
    ? (findByLocalName(emit, "cnpj") || findByLocalName(emit, "CNPJ"))
    : null;
  const emit_cnpj = cnpjEmit ? (cnpjEmit.textContent || "").trim() : "";
  const dest = findByLocalName(infNFe, "dest");
  const cnpjDest = dest
    ? (findByLocalName(dest, "cnpj") || findByLocalName(dest, "CNPJ"))
    : null;
  const dest_cnpj = cnpjDest ? (cnpjDest.textContent || "").trim() : "";

  let dt_emissao = null;
  const ide = findByLocalName(infNFe, "ide");
  if (ide) {
    const dhEmi = findByLocalName(ide, "dhEmi") || findByLocalName(ide, "dEmi");
    if (dhEmi && dhEmi.textContent) {
      const raw = dhEmi.textContent.trim();
      if (raw) dt_emissao = raw;
    }
  }

  const itens = extractItens(doc);
  return { chave_nfe, emit_cnpj, dest_cnpj, dt_emissao, itens };
}

function findByLocalName(parent, localName) {
  if (!parent || !parent.childNodes) return null;
  const name = (localName || "").toLowerCase();
  for (let i = 0; i < parent.childNodes.length; i++) {
    const n = parent.childNodes[i];
    if (n.nodeType === Node.ELEMENT_NODE) {
      const tag = (n.localName || n.tagName || "").toLowerCase();
      if (tag === name) return n;
      const found = findByLocalName(n, localName);
      if (found) return found;
    }
  }
  return null;
}

function getDirectTextContent(node) {
  const parts = [];
  for (let i = 0; i < node.childNodes.length; i++) {
    const n = node.childNodes[i];
    if (n.nodeType === Node.TEXT_NODE) parts.push(n.textContent.trim());
  }
  return parts.join(" ").trim() || "";
}

function extractItens(doc) {
  const dets = doc.querySelectorAll("det");
  if (!dets || dets.length === 0) return [];

  const itens = [];
  for (let i = 0; i < dets.length; i++) {
    const det = dets[i];
    const prod = Array.from(det.children).find((el) => el.tagName === "prod");
    if (!prod) continue;

    let n_item = i + 1;
    const nItemAttr = det.getAttribute("nItem");
    if (nItemAttr != null && nItemAttr !== "") n_item = parseInt(nItemAttr, 10) || i + 1;
    else n_item = i + 1;

    const get = (tag) => {
      const el = findByLocalName(prod, tag) || Array.from(prod.children).find((c) => (c.tagName || "").toLowerCase() === tag.toLowerCase());
      return el ? getDirectTextContent(el) : null;
    };

    const parseNum = (v) => {
      if (v == null || v === "") return null;
      const n = parseFloat(String(v).replace(",", "."));
      return isNaN(n) ? null : n;
    };

    itens.push({
      n_item,
      c_prod: get("cProd") || null,
      x_prod: get("xProd") || null,
      q_com: parseNum(get("qCom")),
      v_un_com: parseNum(get("vUnCom")),
      v_prod: parseNum(get("vProd"))
    });
  }
  return itens;
}
